// ConsoleDebugger
import "maplibre-gl/dist/maplibre-gl.css";
import "./scripts/console-debugger.ts";

import 'bootstrap/dist/css/bootstrap.css';
import 'react-nestable/dist/styles/index.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import { GlobalErrorBoundary } from './common/managers/GlobalErrorBoundary';

// import of Mapit CSS

import './index.css';
import './css/PopBtn.css'
import './css/mitGlassDesign.css'
import './css/Project.css'
import './HLED/index.css'

// Import special css
import './css/plotScreen.css'

// Import overridding themes
import './css/Theme-Newsec.css'
import './css/login.css'

// ADM Body Print 
import './css/printADM.css'

// Bootstrap overrides
import './css/bootstrap-overrides.css'



const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
   <GlobalErrorBoundary>
      <App />
   </GlobalErrorBoundary>
);
// root.render(<div>TEST</div>)


